/* eslint-disable camelcase */
import ufeApi from 'services/api/ufeApi';

const URL = '/gway/v1/genai-pa-entrypoint-prompts/v1/utils/srp_search_terms';

/*
    GAI-7279: fetches the list of search terms that have SRP entrypoint prompts
    available. The backend returns a plain array of strings for the given locale
    (e.g. ['body oil', 'shampoo', ...]). The list is used to decide, on the
    client, whether the AI entrypoint tile should be shown for a search keyword.
*/
const srpSearchTerms = (token, params) => {
    const headers = {
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`
    };

    const query = new URLSearchParams({ locale: params?.locale || '' }).toString();

    return ufeApi
        .makeRequest(`${URL}?${query}`, {
            method: 'GET',
            headers
        })
        .then(data => {
            if (!data || data.errorCode || (data.responseStatus && data.responseStatus !== 200)) {
                return Promise.reject(data);
            }

            // makeRequest resolves with `Object.assign({}, responseData, { responseStatus })`,
            // which turns an array body (['body oil', ...]) into an object with numeric keys plus
            // `responseStatus`. Strip that key and rebuild the ordered list of terms.
            const { responseStatus, ...rest } = data;

            return Object.values(rest);
        });
};

export default srpSearchTerms;
